import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { GoogleAnalyticsService } from './app/core/services/google-analytics.service';
import { GoogleSignInService } from './app/core/services/google-sign-in.service';
import { environment } from './environments/environment';

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
  .then(async (appRef) => {
    const injector = appRef.injector;
    const googleSignInService = injector.get(GoogleSignInService);
    await googleSignInService.loadGoogleScript();

    const googleAnalyticsService = injector.get(GoogleAnalyticsService);
    if (environment.production) {
      googleAnalyticsService.init();
    }
  }).catch(err => console.log(err));
